import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { GET_FILTERS_DATA_API, VISITOR_REPORT_SEARCH_API } from '../utils/api';

function VisitorReports() {
  const [filters, setFilters] = useState({
    name: '',
    mobile: '',
    company: '',
    visitorType: '',
    purpose: '',
    status: '',
    fromDate: '',
    toDate: '',
    userId: '',
    departmentId: '',
    approverId: ''
  });

  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [visitorTypes, setVisitorTypes] = useState([]);
  const [visitPurposes, setVisitPurposes] = useState([]);
  const [approvers, setApprovers] = useState([]);

  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit] = useState(5);
  const [offset, setOffset] = useState(0);

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    fetchFiltersData();
  }, []);

  const fetchFiltersData = async () => {
    try {
      const res = await axios.post(
        GET_FILTERS_DATA_API,
        { token, customer_id: decoded.customer_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setUsers(res.data.users || []);
        setDepartments(res.data.departments || []);
        setVisitorTypes(res.data.visitorTypes || []);
        setVisitPurposes(res.data.visitPurposes || []);
        setApprovers(res.data.approvers || []);
      } else {
        toast.error(res.data.message || 'Failed to load filters');
      }
    } catch {
      toast.error('Error loading filters data');
    }
  };

  const handleSearch = async () => {
    try {
      const payload = {
        token,
        customer_id: decoded.customer_id,
        limit,
        offset: 0,
        ...filters
      };

      Object.keys(payload).forEach(
        (key) => (payload[key] === '' || payload[key] === null) && delete payload[key]
      );

      const res = await axios.post(VISITOR_REPORT_SEARCH_API, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setResults(res.data.visitors || []);
        setTotal(res.data.total || 0);
        setOffset(limit);
      } else {
        toast.error(res.data.message || 'Search failed');
      }
    } catch {
      toast.error('Error searching visitors');
    }
  };

  const handleLoadMore = async () => {
    try {
      const payload = {
        token,
        customer_id: decoded.customer_id,
        limit,
        offset,
        ...filters
      };

      Object.keys(payload).forEach(
        (key) => (payload[key] === '' || payload[key] === null) && delete payload[key]
      );

      const res = await axios.post(VISITOR_REPORT_SEARCH_API, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setResults((prev) => [...prev, ...(res.data.visitors || [])]);
        setOffset(offset + limit);
      } else {
        toast.error(res.data.message || 'Failed to load more');
      }
    } catch {
      toast.error('Error loading more visitors');
    }
  };

  const handleReset = () => {
    setFilters({
      name: '',
      mobile: '',
      company: '',
      visitorType: '',
      purpose: '',
      status: '',
      fromDate: '',
      toDate: '',
      userId: '',
      departmentId: '',
      approverId: ''
    });
    setResults([]);
    setTotal(0);
    setOffset(0);
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h3 className="mb-4">📊 Visitor Reports</h3>

        {/* Filters */}
        <div className="card shadow-sm mb-4">
          <div className="card-body">
            <div className="row g-3">
              {/* Name */}
              <div className="col-md-3">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" name="name" value={filters.name} onChange={handleChange} />
              </div>
              {/* Mobile */}
              <div className="col-md-3">
                <label className="form-label">Mobile</label>
                <input type="text" className="form-control" name="mobile" value={filters.mobile} onChange={handleChange} />
              </div>
              {/* Company */}
              <div className="col-md-3">
                <label className="form-label">Company</label>
                <input type="text" className="form-control" name="company" value={filters.company} onChange={handleChange} />
              </div>
              {/* Visitor Type */}
              <div className="col-md-3">
                <label className="form-label">Visitor Type</label>
                <select className="form-select" name="visitorType" value={filters.visitorType} onChange={handleChange}>
                  <option value="">All</option>
                  {visitorTypes.map((vt) => (
                    <option key={vt.id} value={vt.id}>{vt.name}</option>
                  ))}
                </select>
              </div>
              {/* Purpose */}
              <div className="col-md-3">
                <label className="form-label">Purpose</label>
                <select className="form-select" name="purpose" value={filters.purpose} onChange={handleChange}>
                  <option value="">All</option>
                  {visitPurposes.map((vp) => (
                    <option key={vp.id} value={vp.id}>{vp.name}</option>
                  ))}
                </select>
              </div>
              {/* Status */}
              <div className="col-md-3">
                <label className="form-label">Status</label>
                <select className="form-select" name="status" value={filters.status} onChange={handleChange}>
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
              {/* From Date */}
              <div className="col-md-3">
                <label className="form-label">From Date</label>
                <input type="date" className="form-control" name="fromDate" value={filters.fromDate} onChange={handleChange} />
              </div>
              {/* To Date */}
              <div className="col-md-3">
                <label className="form-label">To Date</label>
                <input type="date" className="form-control" name="toDate" value={filters.toDate} onChange={handleChange} />
              </div>
              {/* Created By */}
              <div className="col-md-3">
                <label className="form-label">Created By (User)</label>
                <select className="form-select" name="userId" value={filters.userId} onChange={handleChange}>
                  <option value="">All</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>{user.name}</option>
                  ))}
                </select>
              </div>
              {/* Approved By */}
              <div className="col-md-3">
                <label className="form-label">Approved By</label>
                <select className="form-select" name="approverId" value={filters.approverId} onChange={handleChange}>
                  <option value="">All</option>
                  {approvers.map((ap) => (
                    <option key={ap.id} value={ap.id}>{ap.name}</option>
                  ))}
                </select>
              </div>
              {/* Department */}
              <div className="col-md-3">
                <label className="form-label">Department</label>
                <select className="form-select" name="departmentId" value={filters.departmentId} onChange={handleChange}>
                  <option value="">All</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="text-end mt-4">
              <button className="btn btn-primary me-2" onClick={handleSearch}>🔍 Search</button>
              <button className="btn btn-secondary" onClick={handleReset}>🔄 Reset</button>
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="card shadow-sm mt-4">
          <div className="card-body">
            {results.length > 0 ? (
              <>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Company</th>
                        <th>Visitor Type</th>
                        <th>Purpose</th>
                        <th>Approval Remark</th>
                        <th>Created By</th>
                        <th>Approved By</th>
                        <th>Department</th>
                        <th>Entry Date</th>
                        <th>Exit Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((v) => (
                        <tr key={v.id}>
                          <td>{v.name}</td>
                          <td>{v.mobile}</td>
                          <td>{v.company}</td>
                          <td>{v.visitor_type_name}</td>
                          <td>{v.visit_purpose_name}</td>
                          <td>{v.approval_remark}</td>
                          <td>{v.created_by_name}</td>
                          <td>{v.approved_by_name}</td>
                          <td>{v.department_name}</td>
                          <td>{v.created_at}</td>
                          <td>{v.out_time}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {results.length < total && (
                  <div className="text-center mt-3">
                    <button className="btn btn-outline-primary" onClick={handleLoadMore}>
                      Load More
                    </button>
                  </div>
                )}
              </>
            ) : (
              <p className="text-muted">No data found. Apply filters to see results.</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default VisitorReports;
